import React from 'react'
import { Link } from 'react-router-dom';
export default function HomeRecent() {
  return (
    <>
<section className='recent-sec'>
<div className='title-top'><h2>Related Career Articles</h2></div>

<div className='container'>
     <div className='listing-box'>
      <div className='list-blog first-block'>
        <div className='card'>
            <div className='image-bx'>
            <img src={'assets/images/Best-Personal.jpg'} alt="" />
            </div>
            <div className='card-detail'>
                 <ul className='date-comment'>
                    <li>October 5, 2022 </li>
                    <li><span>0</span> Comments</li>
                 </ul>
                <h3><Link to='/'>How to Write Personal Statement for Korean University</Link></h3>
            </div>
        </div>

      </div>
      <div className='list-blog'>
        <div className='card'>
            <div className='image-bx'> <img src={'assets/images/Best-Personal.jpg'} alt="" /> </div>
            <div className='card-detail'>
                 <ul className='date-comment'>
                    <li>October 5, 2022 </li> <li><span>0</span> Comments</li>
                 </ul>
                <h3><Link to='/'>How to Write Personal Statement for Korean University</Link></h3>
            </div>
        </div>
      </div>
      <div className='list-blog'>
        <div className='card'>
            <div className='image-bx'> <img src={'assets/images/Best-Personal.jpg'} alt="" /> </div>
            <div className='card-detail'>
                 <ul className='date-comment'>
                    <li>October 5, 2022 </li> <li><span>0</span> Comments</li>
                 </ul>
                <h3><Link to='/'>How to Write Personal Statement for Korean University</Link></h3>
            </div>
        </div>
      </div>

      <div className='list-blog'>
        <div className='card'>
            <div className='image-bx'> <img src={'assets/images/Best-Personal.jpg'} alt="" /> </div>
            <div className='card-detail'>
                 <ul className='date-comment'>
                    <li>October 5, 2022 </li> <li><span>0</span> Comments</li>
                 </ul>
                <h3><Link to='/'>How to Write Personal Statement for Korean University</Link></h3>
            </div>
        </div>
      </div>
      <div className='list-blog'>
        <div className='card'>
            <div className='image-bx'> <img src={'assets/images/Best-Personal.jpg'} alt="" /> </div>
            <div className='card-detail'>
                 <ul className='date-comment'>
                    <li>October 5, 2022 </li> <li><span>0</span> Comments</li>
                 </ul>
                <h3><Link to='/'>How to Write Personal Statement for Korean University</Link></h3>
            </div>
        </div>
      </div>

     </div>


</div>
</section>
    </>
  )
}
